import { DateRange } from '../../models';
import { Component, Input, AfterViewChecked } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'date-range',
  template: require('./date-range.component.pug'),
})
export class DateRangeComponent {
  @Input() fg: FormGroup;

  dateRange: DateRange;

  constructor() {
    this.dateRange = new DateRange();
  }

  get isValid(): boolean {
      let formValue = this.fg.value;
      return moment(formValue.from).isBefore(moment(formValue.to));
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/date-range/date-range.component.ts